import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './home';
import About from './pages/about';
import Services from './pages/services';
import Projects from './pages/projects';
import Contacts from './pages/contacts';
import Header from './components/header';
// import NotFound from './pages/notfound';

const WebRouter = () => (
      
    <div>    
        <Router>
            <Header />
            <Route path="/" exact component={Home} />
            <Route path="/about"  component={About} />
            <Route path="/services"  component={Services} />
            <Route path="/projects"  component={Projects} />
            <Route path="/contact-us"  component={Contacts} />
            {/* <Route path="*"  component={NotFound} /> */}
        </Router> 
    </div>    
     
)

export default WebRouter;


// WEBPACK FOOTER //
// ./src/router.js